import { Breakpoints, ThemeProperties } from "./types";
import uglaTheme from "./uglaTheme";
import cosikaTheme from "./cosikaTheme";

export const breakpoints: Breakpoints = {
    mobile: "480px",
    tablet: "768px",
    desktop: "1024px",
    largeDesktop: "1440px",
};

export const themes: { [key: string]: ThemeProperties } = {
    [uglaTheme.name]: uglaTheme,
    [cosikaTheme.name]: cosikaTheme,
    // Add more themes here
};


export const getTheme = (themeName: string): ThemeProperties => {
    const lowerThemeName = themeName.toLowerCase();
    const theme = themes[lowerThemeName];

    if (!theme) {
        console.warn(`Theme "${themeName}" not found. Default theme is used.`);
        return {...themes['ugla'], breakpoints};
    }

    return {...theme, breakpoints};
};
